import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-stone-50 relative" data-id="element-176" data-mp="1jb1sug4wmy7r">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-177" data-mp="1n9r4o4aao7pa">
        <div className="text-center mb-10" data-id="element-178" data-mp="1s9dgc9ah5fvz">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-blue-950" data-id="element-179" data-mp="1s82am3xgxy28">
            Your Complete <span className="text-orange-600" data-id="element-180" data-mp="1x99jk6bcl3ah">Driving Instructor Ready</span> Package
          </h2>
          <p className="text-slate-700 text-sm md:text-base" data-id="element-181" data-mp="227b46vof9ao2">
            Everything You Need to Plan Less and Teach With More Structure
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-blue-950 border-2 border-orange-500 rounded-3xl p-1 relative shadow-xl shadow-blue-950/15" data-id="element-182" data-mp="7t0e6jw3cagp">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange-600 text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-183" data-mp="1cr4uk1ybj9nw">
            <Sparkles size={14} data-id="element-184" data-mp="25d6ewgqomhs7" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-185" data-mp="20hqzvlgxufu7">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-xl h-auto mx-auto mb-6" loading="lazy" data-id="element-186" data-mp="1vgl5lj7mqkik" />

            <p className="text-sm font-bold tracking-widest text-blue-700 mb-3" data-id="element-187" data-mp="k2pkltu1nhjf">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-stone-50 border border-stone-200 rounded-xl p-4" data-id="element-188" data-mp="g02wa2wl0eqz">
              {packageIncludes.map(item => <li key={item.label} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-189" data-mp="hfx4f97lgneb">
                  {item.kind === 'bonus' ? <Gift size={16} className="text-orange-600 shrink-0 mt-0.5" data-id="element-190" data-mp="7ik65jpg9qnd" /> : <Check size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-191" data-mp="chdk1d8nfjo2" />}
                  <span data-id="element-192" data-mp="3uvw92u8zl38p">{item.label}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-193" data-mp="3j1tfb7s8lvm">
              <p className="text-sm text-slate-500 mb-1" data-id="element-194" data-mp="3k39ju3nnyk7">
                REGULAR VALUE: <span className="line-through" data-id="element-195" data-mp="3l01lrlttijzl">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-196" data-mp="3pymmdmczf5ok">
                <span className="text-2xl md:text-3xl text-slate-600" data-id="element-197" data-mp="3bxa8rhlang5u">TODAY:</span>
                <span className="text-4xl md:text-5xl font-serif font-extrabold text-blue-950" data-id="element-198" data-mp="3fz5inahaj1v8">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-199" data-mp="2xcy06ies2non">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-200" data-mp="31cf61cy49muc">
              <span className="flex items-center gap-1.5" data-id="element-201" data-mp="3g95vate2ti68">
                <Lock size={12} className="text-blue-700" data-id="element-202" data-mp="3g7mhrajt1l85" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-203" data-mp="3b91qi0mj6bvu">
                <Zap size={12} className="text-blue-700" data-id="element-204" data-mp="3p0zhowgadn3q" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-205" data-mp="3l1qrg1kgg7cx">
                <Wallet size={12} className="text-blue-700" data-id="element-206" data-mp="2ut4xcifeld6" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}